<mat-card>
  <mat-card-content style="padding: 1.25rem 0">
    <app-mini-loader *ngIf="loading"></app-mini-loader>
    <app-error *ngIf="error"></app-error>
    <div class="resumen-grid">
      <div class="rseparator margin-line"></div>
      <div class="rseparator2 margin-line"></div>
      <div class="rseparator3 margin-line"></div>

      <div class="resumen-grid-cell data-pair num-poliza margin-grid">
        <span class="data-pair-label">Número de póliza</span>
        <span class="data-pair-value">{{ resumen?.Numero }}</span>
      </div>
      <div class="data-pair inicio-poliza margin-grid">
        <span class="data-pair-label">Inicio de póliza</span>
        <span class="data-pair-value">{{
          resumen?.FechaInicioPoliza | date
        }}</span>
      </div>

      <div class="resumen-grid-cell data-pair tipo-pension margin-grid">
        <span class="data-pair-label">Tipo de pensión</span>
        <span class="data-pair-value">{{ resumen?.TipoPension }}</span>
      </div>

      <div class="resumen-grid-cell data-pair tipo-renta margin-grid">
        <span class="data-pair-label">Tipo de renta</span>
        <span class="data-pair-value">{{ resumen?.TipoRenta }}</span>
      </div>

      <div class="resumen-grid-cell data-pair modalidad margin-grid">
        <span class="data-pair-label">Modalidad</span>
        <span class="data-pair-value">{{ resumen?.ModalidadRenta }}</span>
      </div>

      <div class="resumen-grid-cell data-pair meses-dif margin-grid">
        <span class="data-pair-label">Meses diferidos</span>
        <span class="data-pair-value">{{ resumen?.MesesDiferidos }}</span>
      </div>

      <div class="resumen-grid-cell data-pair meses-garantizados margin-grid">
        <span class="data-pair-label">Meses garantizados</span>
        <span class="data-pair-value">{{ resumen?.MesesGarantizado }}</span>
      </div>

      <div class="resumen-grid-cell data-pair recepcion margin-grid">
        <span class="data-pair-label">Fecha recepción de prima</span>
        <span class="data-pair-value">{{
          resumen?.FechaRecepcionPrima | date
        }}</span>
      </div>

      <div class="resumen-grid-cell data-pair prima-total margin-grid">
        <span class="data-pair-label">Prima total recibida</span>
        <span class="data-pair-value">{{ resumen?.PrimaTotalRecibida }}</span>
      </div>
    </div>
  </mat-card-content>
</mat-card>
